// Always-visible badge while transcription is listening or transcribing.
// Reminds the user that audio is being captured and sent to the
// configured cloud provider.

import { useStore } from '../state/store';

export function RecordingIndicator() {
  const status = useStore((s) => s.transcriptionStatus);
  if (status === 'disconnected' || status === 'idle') return null;
  const label =
    status === 'listening' ? 'LIVE — sending to OpenAI'
    : status === 'transcribing' ? 'TRANSCRIBING — sending to OpenAI'
    : 'TRANSCRIPTION ERROR';
  return (
    <div className={`recording-indicator recording-indicator--${status}`} role="status" aria-live="polite">
      <span className="recording-dot" />
      {label}
    </div>
  );
}
